import "./profile.scss";
import { useState } from "react";
import { useProfileLogic } from "./hooks/useProfileLogic";
import ProfileHeader from "./components/ProfileHeader";
import Posts from "../../components/posts/Posts";
import Update from "../../components/update/Update";

const Profile = () => {
    const logic = useProfileLogic();
    const [openUpdate, setOpenUpdate] = useState(false);

    if (logic.loading) return <div className="profile">Loading...</div>;

    return (
        <div className="profile">
            <ProfileHeader 
                user={logic.userData} 
                logic={logic} 
                setOpenUpdate={setOpenUpdate}
            />

            <div className="profileContainer bottom-feed">
                <Posts userId={logic.userId} />
            </div>

            {openUpdate && 
                <Update setOpenUpdate={setOpenUpdate} user={logic.userData} />
            }
        </div>
    );
};
export default Profile;